import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; _forEachInstanceProperty(_context = ownKeys(Object(source), true)).call(_context, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context2; _forEachInstanceProperty(_context2 = ownKeys(Object(source))).call(_context2, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { text, icon, padding } from '@rexlabs/styling';
export function getCompactTokens(target) {
  return {
    tag: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, text.tokens({
      target: [target, 'tag.compact'],
      fallback: 'small.semibold'
    })), icon.tokens({
      target: [target, 'tag.compact'],
      size: 's'
    })), padding.tokens({
      target: [target, 'tag.compact'],
      x: 'xs',
      y: 'xxxs'
    })), {}, {
      height: function height(_ref) {
        var token = _ref.token;
        return token("".concat(target, ".height"), token('tag.compact.height', '2rem'));
      },
      closeButton: {
        height: function height(_ref2) {
          var token = _ref2.token;
          return token("".concat(target, ".closeButton.height"), token('tag.compact.closeButton.height', '1.2rem'));
        },
        width: function width(_ref3) {
          var token = _ref3.token;
          return token("".concat(target, ".closeButton.width"), token('tag.compact.closeButton.width', '1.2rem'));
        }
      }
    })
  };
}